import { ISiteLocation } from '~/client/graph'

/**
 * A multi-value location field with `next` as its first value, the one its pin belongs
 * to. When the pin lands on a location already in the set, that location moves first with
 * its own levels instead of being repeated.
 */
export function withPrimaryLocation(
  values: readonly ISiteLocation[],
  next: ISiteLocation,
): ISiteLocation[] {
  const others = values.filter(value => value?.id).slice(1)
  const matched = others.find(value => value.id === next?.id)

  return [
    matched ? { ...matched, preciseLocation: next.preciseLocation } : next,
    ...others.filter(value => value.id !== next?.id),
  ]
}
